module.exports = __webpack_public_path__ + "img/Banks.deb081c1.svg";